import React from "react";
import Modal from "./Modal";

export default function ConfirmModal({
    open,
    title = "Bekr�ft",
    message,
    confirmText = "Ja",
    cancelText = "Annuller",
    tone = "danger", // "danger" | "primary"
    onConfirm,
    onCancel,
    busy,
}: {
    open: boolean;
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    tone?: "danger" | "primary";
    onConfirm: () => void;
    onCancel: () => void;
    busy?: boolean;
}) {
    return (
        <Modal open={open} title={title} onClose={onCancel}>
            <div style={{ display: "grid", gap: 12 }}>
                <div style={{ color: "#333", lineHeight: 1.4 }}>{message}</div>

                <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                    <button className="cancel-btn" onClick={onCancel} disabled={!!busy}>
                        {cancelText}
                    </button>

                    <button
                        className={tone === "danger" ? "delete-btn" : "add-btn"}
                        onClick={onConfirm}
                        disabled={!!busy}
                    >
                        {busy ? "Arbejder..." : confirmText}
                    </button>
                </div>
            </div>
        </Modal>
    );
}